import React, { useState } from "react";
import {
  Title,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  MyActionButton,
} from "../../component/Component";
import { getOneEmail } from "../../../../middlewares/sysNavigation/SysNavigation";
import { useStaticContext } from "../../../../context/static/StaticContext";

const Edit = () => {
  const { updateOneEmailTemplate } = useStaticContext();
  const email = getOneEmail();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const email_templates_id = email.email_templates_id;
  const [title, setTitle] = useState(email.title);
  const [description, setDescription] = useState(email.message);

  const emailRoutes = "/email";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (error, message) => {
    setError(error);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const updateOneEmailHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = { title: title, message: description };

    const { message, status } = await updateOneEmailTemplate({
      data,
      id: email_templates_id,
    });

    setLoading(false);
    if (status === 200) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  return (
    <div className="h-full overflow-hidden rounded-b-xl bg-gradient-to-b from-gray-50 to-white">
      {/* Sticky top bar */}
      <div className="sticky top-0 z-10 border-b bg-white/80 px-3 py-3 backdrop-blur supports-[backdrop-filter]:bg-white/60 lg:px-6">
        <div className="mx-auto flex max-w-5xl items-center justify-between">
          <GoBack props={{ route: emailRoutes }} />
          <span className="hidden text-[11px] text-gray-500 sm:inline">
            Template ID: <span className="font-medium text-gray-700">#{email_templates_id}</span>
          </span>
        </div>
      </div>

      <form
        onSubmit={updateOneEmailHandler}
        aria-busy={loading}
        className="mx-auto h-[calc(100%-56px)] max-w-5xl overflow-y-auto px-3 py-4 lg:px-6"
      >
        {/* Messages */}
        <div className="mb-3">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />
        </div>

        {/* Header card */}
        <div className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <Title props={{ title: "Email Template" }} />
              <p className="mt-1 text-[11px] text-gray-500">
                Keep the subject clear and the message concise.
              </p>
            </div>
            <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
              <span
                className={[
                  "h-1.5 w-1.5 rounded-full",
                  loading ? "bg-amber-500" : success ? "bg-emerald-500" : "bg-gray-300",
                ].join(" ")}
              />
              {loading ? "Saving…" : success ? "Saved" : "Editing"}
            </span>
          </div>
        </div>

        {/* Content card */}
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="grid grid-cols-1 gap-4 p-4">
            <div className="rounded-lg border bg-gray-50/60 p-3 hover:bg-gray-50">
              <InputField
                props={{
                  id: "title",
                  title: "Subject",
                  type: "text",
                  value: title ? title : "",
                  onChange: (e) => {
                    setTitle(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>

            <div className="rounded-lg border bg-gray-50/60 p-3 hover:bg-gray-50">
              <TextArea
                props={{
                  id: "description",
                  title: "Message",
                  type: "text",
                  value: description ? description : "",
                  rows: 8,
                  onChange: (e) => {
                    setDescription(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
              <p className="mt-2 text-[11px] text-gray-500">
                Tip: Use short paragraphs and avoid jargon.
              </p>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="sticky bottom-0 mt-4 border-t bg-white/80 px-2 py-3 backdrop-blur supports-[backdrop-filter]:bg-white/60">
          <div className="flex items-center justify-end">
            <MyActionButton
              title="Save Changes"
              loading={loading}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Edit;
